import { Page, useFocusEffect } from '@betty/navigation';
import Promos from '../components/Promos';
import { useDispatch } from '@betty/toolkit/state';
import { useCallback } from 'react';
import { getPromos } from '../state';

function PromosPage() {
  const dispatch = useDispatch();

  useFocusEffect(
    useCallback(() => {
      dispatch(getPromos());
    }, [dispatch]),
  );

  return (
    <Page restrictWidth>
      <Promos />;
    </Page>
  );
}

export default PromosPage;
